import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import VermittelCounterApp from "../components/vermittelt-counter/VermittelCounterApp.vue";

export default () => {
  const numbers = document.querySelectorAll(".vermittelt-counter .number");
  if (!numbers) {
    return;
  }

  depsloader.load("vue-i18n").then((vueI18n) => {
    Vue.use(vueI18n.VueI18n);

    for(const element of numbers) {
      new Vue({
        el: element,

        components: {
          VermittelCounterApp
        },

        computed: {
          numberValue() {
            if (element.dataset.numbervalue) {
              return element.dataset.numbervalue;
            }

            return 0;
          }
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(VermittelCounterApp)
      });
    }
  });
}
